// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3rBrM","inner":"Form_inner__24034","range":"Form_range__18dNp","name":"Form_name__3_8fF","actions":"Form_actions__2Ks4m"};